// 获取元素总偏移量
export function setOffset(event) {
    let x = event.offsetLeft

    if(event.offsetParent && event.offsetParent.nodeName !== 'body'){
        return x + setOffset(event.offsetParent)
    }
    else {
        return x
    }

}


// WEBPACK FOOTER //
// ./src/api/util.js